import {
  ChangeDetectionStrategy,
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { MarkantElementsModule } from '@markant/elements-angular';
import { SharedDialogFeatureModule } from '@markant-platform/shared/dialog/feature';
import { TranslocoPipe } from '@jsverse/transloco';
import { Filter, TranslatedFilter } from '@markant-platform/shared/ui-filter';
import { MarkantSelectOption } from '@markant-platform/shared/util-helpers';

@Component({
  selector: 'markant-platform-report-confirmation-dialog',
  standalone: true,
  imports: [CommonModule, MarkantElementsModule, SharedDialogFeatureModule, TranslocoPipe],
  templateUrl: './report-confirmation-dialog.component.html',
  styleUrl: './report-confirmation-dialog.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportConfirmationDialogComponent implements OnChanges {
  @Input({ required: true }) open = false;
  @Input({ required: true }) headline = '';
  @Input({ required: true }) approveButtonText = '';
  @Input({ required: true }) descriptionText = '';
  @Input({ required: true }) label = '';
  @Input({ required: true }) filtersAppliedLabel = '';
  @Input({ required: true }) searchKey = '';
  @Input() totalResultsCount = 0;
  @Input() filters: Filter<MarkantSelectOption> = {};
  @Input() activeFilters: Record<string, string[]> = {};
  @Input() searchQuery = '';
  @Output() openChange = new EventEmitter<void>();
  @Output() runExport = new EventEmitter<void>();

  filtersCount = 0;
  parsedFilters: TranslatedFilter[] = [];

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['open'] && this.open) {
      this.filtersCount = this.filters ? Object.keys(this.filters).length : 0;
      this.parsedFilters = [];
      for (const filterGroupKey of Object.keys(this.activeFilters)) {
        this.parsedFilters.push({
          groupTranslatedKey: this.filters[filterGroupKey].translationKey ?? '',
          values: this.getActiveFilterValueTranslationKey(filterGroupKey),
        });
      }
      if (this.searchQuery) {
        this.parsedFilters.push({
          groupTranslatedKey: this.searchKey ?? '',
          values: [{ value: this.searchQuery, representation: this.searchQuery } as MarkantSelectOption],
        });
      }
    }
  }

  exportData(): void {
    this.runExport.emit();
  }

  closeDialog(): void {
    this.openChange.emit();
  }

  private getActiveFilterValueTranslationKey(key: string): MarkantSelectOption[] {
    return this.activeFilters[key].map(
      filterValue =>
        this.filters[key].filterOptions.find(option => option.value === filterValue) ?? ({} as MarkantSelectOption)
    );
  }
}
